import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getAllTaskLists } from "~/store/selectors/selector.taskLists";
import { getAllTasks, getTaskById } from "~/store/selectors/selector.tasks";
import { getUserWorkProjects, userWork } from "~/store/selectors/selector.userTasks";

const defaultValue = [null, null];
export const useMyWorkByProjectNavigation = (taskId, userId) => {
  const task = useSelector((state) => getTaskById(state, taskId));
  const projects = useSelector((state) => getUserWorkProjects(state, userId));
  const myWorkData = useSelector((state) => userWork(state, userId));
  const allTasks = useSelector(getAllTasks);
  const allTaskLists = useSelector(getAllTaskLists);

  const items = useMemo(() => {
    let result = [];
    if (!task) {
      return result;
    }
    if (projects && myWorkData) {
      const ids = myWorkData.projects ? myWorkData.projects : [];
      result = ids.reduce((prev, next) => {
        let taskListIds = myWorkData.taskListByProjectMap[next] || [];
        let listsBySubtasks = Object.keys(myWorkData.subtaskTasksByTaskListMap);
        taskListIds = [...new Set([...taskListIds, ...listsBySubtasks])];
        taskListIds.forEach((tl) => {
          const tasks = myWorkData.tasksByTaskListMap[tl] ? myWorkData.tasksByTaskListMap[tl] : [];
          const tasksSubtasks = myWorkData.subtaskTasksByTaskListMap[tl] || [];
          prev = [...new Set([...prev, ...tasks, ...tasksSubtasks])];
        });

        return prev;
      }, []);
    }

    const mapOfIndexes = projects.reduce((acc, next, index) => {
      acc[next.id] = index;
      return acc;
    }, {});
    return result
      .sort((a, b) => {
        const first = allTasks.get(`${a}`);
        const second = allTasks.get(`${b}`);
        if (first && second) {
          return mapOfIndexes[first.project_id] < mapOfIndexes[second.project_id] //sortiraj po projektima
            ? -1
            : 1;
        }
        return 0;
      })
      .sort((a, b) => {
        const first = allTasks.get(`${a}`);
        const second = allTasks.get(`${b}`);
        if (first && second) {
          if (first.task_list_id === second.task_list_id) {
            if (!myWorkData.subtasksByTaskMap[a] && myWorkData.subtasksByTaskMap[b]) {
              return 1;
            }
            if (myWorkData.subtasksByTaskMap[a] && !myWorkData.subtasksByTaskMap[b]) {
              return 1;
            }
            return first.position < second.position ? -1 : 1; //sortiraj po njihovoj poziciji u listi
          }
          if (first.project_id === second.project_id) {
            const firstList = allTaskLists.get(`${first.task_list_id}`);
            const secondList = allTaskLists.get(`${second.task_list_id}`);
            if (firstList && secondList) {
              return firstList.position < secondList.position ? -1 : 1; //sortiraj po redosledu liste
            }
          }
        }
        return 0;
      });
  }, [task, projects, myWorkData, allTaskLists, allTasks]);

  if (!task) {
    return defaultValue;
  }

  const current = items.findIndex((i) => i === task.id);
  const previous = current > -1 && items[current - 1] ? items[current - 1] : null;
  const next = current > -1 && items[current + 1] ? items[current + 1] : null;
  return [previous, next];
};
